import { resizeFile } from "../../../../../utils/compressImage";

const handleImageUpload = async (
  e,
  setImageFormatErrorText,
  arrayHelpers,
  index,
  docPerKind,
  t
) => {
  const images = ["image/png", "image/gif", "image/jpeg"];

  const correctType = images.find((type) => type === e.target.files[0].type);

  if (correctType) {
    // resizeImage(e.target.files[0]);
    if (e.target.files[0].size > 3145728) {
      setImageFormatErrorText(t("Image should up to 3mb"));
    } else {
      let fileToBeUploaded = e.target.files[0];

      const file = await resizeFile(fileToBeUploaded);

      setImageFormatErrorText("");
      arrayHelpers.replace(index, {
        id: docPerKind?.id,
        doc_id: docPerKind?.doc_id,
        // Convert filelist to array
        files: [file],
      });
    }
    // }
  } else {
    setImageFormatErrorText(t("Image is not correct"));
    arrayHelpers.replace(index, {});
  }
};

export default handleImageUpload;
